import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getEducationLevels,
  getDetailYearLevels,
} from "../../../../ducks/AcademicAdministrationDucks";
import SectionCollapsible from "./SectionCollapsible";
import { axiosGet, axiosPost } from "../../../../utils/AxiosApi";
import {
  URL,
  draggable,
  checkRolePermissions,
  checkWidgetAdminOrNot,
} from "../../../../utils/Constants";
import swal from "sweetalert";
import {
  displayConfirmDeleteAlert,
  displayErrorAlert,
} from "../../../../utils/Utils";
import ModalWindow from "./../../../UI/ModalWindow";
import GranularPermissionModal from "./../../../Permissions/GranularPermissionModal";
import { Spinner } from "reactstrap";
import { checkPermissionForSubstituteTeachers } from "./../../../../utils/Constants";
import Select from "react-select";

class ClassroomList extends Component {
  state = {
    detailYearLevels: [],
    educationLevels: [],
    classroomLocations: [],
    classroomTeachers: [],
    name: "",
    recruitmentId: "",
    roomId: "",
    termAlias:
      localStorage.getItem("classroom") === null
        ? "Section"
        : localStorage.getItem("classroom"),
    assessmentModules: [],
    selectedClassroomToExportData: null,
    classrooms: [],
    permissionModal: false,
    exportSpinnner: false,
  };

  componentDidMount() {
    this.props.getDetailYearLevels();
    this.getStaffList();
    this.getRooms();
    this.getAssessmentModules();
  }

  getAssessmentModules = () => {
    axiosPost(URL.getAssesmentModules, {}, (response) => {
      if (response.status === 200) {
        this.setState({ assessmentModules: response.data.data });
      }
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.detailYearLevels !== this.props.detailYearLevels) {
      let detailYearLevels = this.props.detailYearLevels;
      detailYearLevels.forEach((el) => {
        el.yearLevels.forEach((el1) => {
          el1.classrooms.forEach((el2) => {
            el2.isOpen = false;
          });
        });
      });
      this.setState({ detailYearLevels });
    }
  }

  handleSectionLevelUpdateBtnClick = (index, yearLevelIdx, classroomIdx) => {
    let detailYearLevels = [...this.state.detailYearLevels];
    detailYearLevels.forEach((el) => {
      el.yearLevels.forEach((el1) => {
        el1.classrooms.forEach((el2) => {
          el2.isOpen = false;
        });
      });
    });
    detailYearLevels[index].yearLevels[yearLevelIdx].classrooms[
      classroomIdx
    ].isOpen = true;

    this.setState({
      detailYearLevels,
      name: detailYearLevels[index].yearLevels[yearLevelIdx].classrooms[
        classroomIdx
      ].name,
      recruitmentId:
        detailYearLevels[index].yearLevels[yearLevelIdx].classrooms[
          classroomIdx
        ].recruitmentId || "",
      roomId:
        detailYearLevels[index].yearLevels[yearLevelIdx].classrooms[
          classroomIdx
        ].roomId || "",
    });
  };

  handleSectionLevelCancelBtnClick = (e) => {
    e.preventDefault();
    let detailYearLevels = [...this.state.detailYearLevels];
    detailYearLevels.forEach((el) => {
      el.yearLevels.forEach((el1) => {
        el1.classrooms.forEach((el2) => {
          el2.isOpen = false;
        });
      });
    });
    this.setState({ detailYearLevels });
  };

  getRooms = () => {
    axiosPost(URL.roomSelect, {}, (response) => {
      if (response.status === 200) {
        this.setState({ classroomLocations: response.data.data });
      }
    });
  };

  getStaffList = () => {
    axiosPost(URL.getStaffList, {}, (response) => {
      if (response.status === 200) {
        this.setState({ classroomTeachers: response.data.data });
      }
    });
  };

  handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (name === "name") {
      if (!value.match(this.state.regEx)) {
        let errorCharacter = value.slice(-1);
        swal({
          title: "Warning",
          text: `${errorCharacter} not allowed`,
          allowOutsideClick: false,
          closeOnClickOutside: false,
        });
        draggable();
      } else {
        this.setState({ [name]: value });
      }
    } else {
      this.setState({ [name]: value });
    }
  };

  handleSectionTeacherChange = (option) => {
    this.setState({ recruitmentId: option?.value });
  };

  updateTuple = (e, id) => {
    e.preventDefault();
    let data = {
      id: id,
      name: this.state.name,
      recruitmentId:
        this.state.recruitmentId !== ""
          ? parseInt(this.state.recruitmentId)
          : null,
      roomId: this.state.roomId,
    };
    axiosPost(URL.updateClassroom, data, (response) => {
      if (response.status === 200) {
        swal({
          title: "Success",
          text: `${this.state.termAlias} has been updated`,
          allowOutsideClick: false,
          closeOnClickOutside: false,
        });
        draggable();
        this.props.getDetailYearLevels();
      }
    });
  };

  deleteRecods = (e, id) => {
    e.preventDefault();
    displayConfirmDeleteAlert(id, this.deleteTuple);
  };

  deleteTuple = (id) => {
    axiosPost(URL.deleteClassroom, { id: id }, (response) => {
      if (response.status === 200) {
        const message = response.data.message;
        const deleteRecord = !message.includes("containing");
        swal({
          title: deleteRecord ? "Success" : "Oops",
          text: message,
          allowOutsideClick: false,
          closeOnClickOutside: false,
        });
        draggable();
        this.props.getDetailYearLevels();
      }
    });
  };

  handleSelectedClassroomToExportData = (selectedOption) => {
    this.setState({
      selectedClassroomToExportData: selectedOption || null,
    });
  };

  handleExport = () => {
    const { selectedClassroomToExportData } = this.state;

    // if (!selectedClassroomToExportData) {
    //   swal({
    //     title: "Warning",
    //     text: "Please select a classroom to export",
    //     allowOutsideClick: false,
    //     closeOnClickOutside: false,
    //   });
    //   draggable();
    //   return;
    // }
    this.setState({ exportSpinnner: true }, function () {
      axiosPost(
        URL.exportStudentDataForClassroom,
        {
          yearLevelId: selectedClassroomToExportData?.yearLevelId,
          classroomId: selectedClassroomToExportData?.classroomId,
        },
        (response) => {
          if (response.data.path) {
            const filePath = URL.downloadURL + response.data.path;
            const link = document.createElement("a");
            link.href = filePath;
            link.download = "";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          this.setState({ exportSpinnner: false });
        },
        (error) => {
          swal({
            title: "Oops!",
            text: error?.response?.data?.message,
          });
          this.setState({ exportSpinnner: false });
        },
      );
    });
  };

  getGroupedOptions = () => {
    const { detailYearLevels } = this.state;
    if (!detailYearLevels || !Array.isArray(detailYearLevels)) return [];

    // Flatten all year levels from all education levels
    const allYearLevels = detailYearLevels.flatMap(
      (educationLevel) => educationLevel.yearLevels || [],
    );

    // Group by year level (Class)
    return allYearLevels.map((yearLevel) => {
      const yearLabel = yearLevel.name || yearLevel.coreName || "Unnamed Year";

      // Map classrooms under this year level
      let subgroup = [
        {
          value: yearLevel.id,
          label: `All Classrooms in ${yearLabel}`,
          classroomId: null,
          yearLevelId: yearLevel.id,
        },
      ];
      let subOptions = (yearLevel.classrooms || []).map((classroom) => ({
        value: classroom.id,
        label: `${yearLabel} - ${classroom.name}`,
        classroomId: classroom.id,
        yearLevelId: yearLevel.id,
      }));
      subOptions = [...subgroup, ...subOptions];
      return {
        label: `${yearLabel}`,
        options: subOptions,
      };
    });
  };

  render() {
    const {
      detailYearLevels,
      selectedClassroomToExportData,
      permissionModal,
      termAlias,
    } = this.state;

    const groupedOptions = this.getGroupedOptions();

    return (
      <div className="tt-widgetContent-tab-holder" style={{ height: "79.5vh" }}>
        <div className="tt-group-header">
          List {termAlias}
          {checkWidgetAdminOrNot("Academic Administration") && (
            <button
              className="tt-button tt-button-primary float-right permissionBtnCSS"
              onClick={() =>
                this.setState({ permissionModal: !permissionModal })
              }
            >
              Permissions
            </button>
          )}
        </div>

        {/* 🔽 Grouped react-select dropdown + Export */}
        <div className="d-flex justify-content-end my-2">
          <div style={{ width: "300px", marginRight: "10px" }}>
            <Select
              placeholder="Select classroom"
              value={selectedClassroomToExportData}
              onChange={this.handleSelectedClassroomToExportData}
              options={groupedOptions}
              isClearable
              classNamePrefix="react-select"
            />
          </div>

          <button
            className="tt-button tt-button-primary"
            onClick={this.handleExport}
            disabled={this.state.exportSpinnner}
          >
            {!!this.state.exportSpinnner ? (
              <div className="text-center">
                <Spinner color="white" size={"sm"} />
              </div>
            ) : (
              "Export"
            )}
          </button>
        </div>

        {/* 📋 Table Section */}
        <div className="tt-newListBox">
          {detailYearLevels.length > 0 ? (
            detailYearLevels.map((el, index) =>
              el.yearLevels.map((element, yearLevelIdx) =>
                element.classrooms ? (
                  <table
                    className="table table-bordered table-striped"
                    key={`${index}-${yearLevelIdx}`}
                  >
                    <thead className="tt-group-header">
                      <tr>
                        <th colSpan="4">Class {element.name}</th>
                      </tr>
                    </thead>
                    <thead className="tt-group-header-dark">
                      <tr>
                        <th width="20%">{termAlias}</th>
                        <th width="40%">Teachers</th>
                        <th width="40%">Location</th>
                        <th width="20%">Options</th>
                      </tr>
                    </thead>
                    <tbody>
                      {element.classrooms.length > 0 ? (
                        element.classrooms.map((classroom, classroomIdx) => (
                          <SectionCollapsible
                            key={classroomIdx}
                            yearLevel={element.name}
                            classroom={classroom}
                            yearLevelId={element.id}
                            classroomIdx={classroomIdx}
                            yearLevelIdx={yearLevelIdx}
                            assessmentModuleCode={el.assessmentModuleCode}
                            index={index}
                            handleSectionLevelUpdateBtnClick={
                              this.handleSectionLevelUpdateBtnClick
                            }
                            handleSectionLevelCancelBtnClick={
                              this.handleSectionLevelCancelBtnClick
                            }
                            handleChange={this.handleChange}
                            {...this.state}
                            updateTuple={this.updateTuple}
                            deleteRecods={this.deleteRecods}
                            handleSectionTeacherChange={
                              this.handleSectionTeacherChange
                            }
                            assessmentModules={this.state.assessmentModules}
                          />
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4}>No data available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                ) : (
                  <div className="text-center">No data available</div>
                ),
              ),
            )
          ) : (
            <div className="text-center">
              {this.props.sectionSpinner ? (
                <>
                  <Spinner
                    color="primary"
                    style={{ marginTop: "200px" }}
                  ></Spinner>
                  <br />
                  Loading Data...
                </>
              ) : (
                "No data"
              )}
            </div>
          )}
        </div>

        {/* ⚙️ Permissions Modal */}
        <ModalWindow
          modal={permissionModal}
          size="lg"
          id="tt-permissionModal"
          toggleModal={() =>
            this.setState({ permissionModal: !permissionModal })
          }
          modalHeader={"Assign permission to user"}
          modalBody={
            <GranularPermissionModal
              widgetName="Academic Administration"
              moduleName="School Groupings"
              header={`List ${termAlias}`}
              activityName="select-section"
            />
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  detailYearLevels: state.academicAdministration.detailYearLevels,
  educationLevels: state.academicAdministration.educationLevels,
  sectionSpinner: state.academicAdministration.sectionSpinner,
});

const mapActionsToProps = {
  getDetailYearLevels,
  getEducationLevels,
};

export default connect(mapStateToProps, mapActionsToProps)(ClassroomList);
